"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositFields = void 0;
var DepositFields_1 = require("./DepositFields");
Object.defineProperty(exports, "DepositFields", { enumerable: true, get: function () { return __importDefault(DepositFields_1).default; } });
